import React, { useState } from 'react';
import BusinessInfo from '../../assets/icons/BusinessInfo';
import LogoBlack from '../LogoBlack';
import StepCard from './stepCard';

interface NavigationProps {
  activeStep: number;
}

const stepInformation = [
  {
    title: 'Business Type',
    subtext: ' Selecting your business type lets Esemie ',
    subtext2: ' tailor your page for your specific needs.',
    icon: <BusinessInfo isWhite={false} />,
  },
  {
    title: 'Business Info',
    subtext: ' Fill in the basic information to get started.',
    subtext2: '',
    icon: <BusinessInfo isWhite={false} />,
  },
  {
    title: 'Brand Identity',
    subtext: ' Customize your account to align with',
    subtext2: ' your brand.',
    icon: <BusinessInfo isWhite={false} />,
  },
  {
    title: 'Bank Account',
    subtext: ' Enter bank account details. This will be',
    subtext2: ' on all invoices created for your customer',
    icon: <BusinessInfo isWhite={false} />,
  },
];

const Navigation: React.FC<NavigationProps> = ({ activeStep }) => {

  return (
    <div className=" fixed w-3/10 p-4">
        <div className='px-[3em] py-[4em] flex justify-center'>
        <LogoBlack/>
        </div>
      {stepInformation.map((step, index) => (
        <StepCard
          key={index}
          title={step.title}
          icon={step.icon}
          isActive={activeStep === index}
          isCompleted={activeStep > index}
          subtext={step.subtext}
          subtext2={step.subtext2}
    
        />
      ))}
    </div>
  );
};

export default Navigation;
